export default __webpack_public_path__ + "static/media/man.a81c398b.png";